module.exports = __webpack_public_path__ + "static/media/scr.d29c27e6.gif";